import React, {useCallback, useEffect, useState} from 'react';
import {BoxTitle} from "../../../components/admin/BoxTitle";
import {useParams} from "react-router-dom";
import {Loader} from "../../../components/admin/Loader";
import {ApiService} from "../../../service/ApiService";
import {seasonResultType} from "../../../types/Api/SeasonResultType";
import {seasonHydrator} from "../../../models/hydrator/seasonHydrator";
import {season} from "../../../models/season";
import {SeasonShow} from "../../../components/admin/season/SeasonShow";

export const Show = () => {
  const uuid: undefined | string = useParams().uuid;

  const [loading, setLoading] = useState(false);
  const [season, setSeason] = useState(undefined as undefined | season);

  const findSeason = useCallback(() => {
    if (uuid) {
      const result = ApiService.get(`/season/${uuid}`) as Promise<seasonResultType>;

      setLoading(true);

      result
        .then((r) => {
          setSeason(seasonHydrator.hydrate(r));
        })
        .catch(() => {
          alert("Une erreur c'est produite.")
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [uuid]);

  useEffect(() => {
    findSeason()
  }, [findSeason]);

  return (
    <>
      {loading && (
        <Loader/>
      )}
      {!loading && season && (<>
        <BoxTitle title="Modifier une saison"/>
        <SeasonShow season={season}/>
      </>)}

    </>
  )
}
